/** @format */

import { useCallback, useState, useEffect } from "react";
import { Markup } from "interweave";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocale } from "../../../i18n/hooks";

import {
  useUpdateUserTermsMutation,
  useGetUserQuery,
} from "../../../app/services/userApi";

import termsConditions from "./termsConditions.json";

const TermsConditions = () => {
  const { t: _ } = useTranslation();
  const location = useLocation();
  const locale = useLocale();

  const [show, setShow] = useState<boolean>(false);
  const { data: User } = useGetUserQuery();
  const [updateUserTerms, { isUninitialized, isLoading: updatingUser }] =
    useUpdateUserTermsMutation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleAccept = useCallback(() => {
    updateUserTerms({ terms: termsConditions["published-date"] });
  }, [updateUserTerms]);

  useEffect(() => {
    if (User) {
      if (User?.termsConditions !== termsConditions["published-date"]) {
        handleShow();
      } else {
        handleClose();
      }
    }
  }, [User]);

  return (
    <Modal show={show} className="terms-conditions-modal" size="lg">
      <Modal.Header>
        <Modal.Title>{_("Terms and Conditions")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="terms-conditions">
          <Markup
            tagName="div"
            content={termsConditions["terms-conditions"][locale]}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link to="/auth/logout" state={{ from: location }}>
          <Button variant="light" onClick={handleClose}>
            {_("Decline")}
          </Button>
        </Link>

        <Button variant="editing" onClick={handleAccept}>
          {isUninitialized && !updatingUser ? _("Accept") : <Spinner />}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsConditions;
